import React from 'react'; // Removed useContext
import { useSelector, useDispatch, useStore } from 'react-redux'; // Added Redux hooks
import { Button } from 'antd';
import DateTimePicker from '../DateTimePicker';
import FieldUsers from '../FieldUsers';
import ValidateScheduling from './ValidateScheduling';
import finalize from './finalize';

export default function LeftPanel({ setVisible, modalType }) {
  const dispatch = useDispatch();
  
  // We use useStore so we can get the full state inside the onClick function
  // without subscribing this component to every single state change.
  //const store = useStore();

  // 1. Select ONLY the data required for the UI to render.
  // This component will now only re-render if these specific fields change.
  const inspector = useSelector(state => state.inspector);
  const project = useSelector(state => state.project);
  const time = useSelector(state => state.time);
  const date = useSelector(state => state.date);
  const duration = useSelector(state => state.duration);

  // Group them for the validator (this is cheap to do on every render)
  const scheduled = { time, date, duration, inspector, project };
  
  const validator = new ValidateScheduling();
  const finalizable = validator.validate(scheduled, false);

  const handleFinalize = async () => {
    if (!finalizable) return;
    try {
      await finalize(scheduled, dispatch);
    } catch (e) {
      console.error(e);
    } finally {
      if (setVisible) setVisible(false);
    }
  };

  console.log('LeftPanel renders');

  return (
    <div>
      <div
        style={{ flex: 4, position: 'relative' }}
        className="overflow-scroll padding-1 flex-column schedule-inspections-left-panel"
      >
        {/* NOTE: FieldUsers and DateTimePicker must also be converted to use Redux! */}
        <FieldUsers modalType={modalType} /> 
      
        {modalType && inspector.id && <DateTimePicker />}
      </div>
      
      {modalType && (
        <div
          className="full-width padding-2"
          style={{
            visibility: finalizable ? 'visible' : 'hidden',
            height: finalizable ? 40 : 0,
            transition: 'height 1s',
          }}
        >
          <Button
            onClick={handleFinalize}
            style={{ alignSelf: 'flex-end', height: 'inherit' }}
            type="primary"
          >
            Schedule Inspection
          </Button>
        </div>
      )}
    </div>
  );
}